import { render } from "./AdditionalName.vue?vue&type=template&id=aca95398"
import script from "./AdditionalName.vue?vue&type=script&lang=js"
export * from "./AdditionalName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__